export default {
  markerSelected: null,
  oligoAndProbeDataSelected: null,
  resultItemSelected: null,
};
